import React from 'react'
import { Badge, Popover, OverlayTrigger } from 'react-bootstrap'

export function StatusBadges({ status, direction = 'row' }) {
  const flexDirection = direction === 'row' ? '' : 'flex-column'
  const baseBadgeStyling = 'mx-2 my-auto'
  const badgeStyling = {
    ok: { className: `${baseBadgeStyling} bg-success` },
    error: { className: ` ${baseBadgeStyling} bg-danger` },
    neutral: { className: `${baseBadgeStyling} bg-secondary` },
  }

  return (
    <div className={`d-flex ${flexDirection}`}>
      {status.map(item => {
        return (
          <div key={item.text}>
            <OverlayTrigger
              trigger={['hover', 'focus']}
              placement="bottom"
              overlay={<Popover id=''>{item.helpText}</Popover>}
            >
              <Badge {...badgeStyling[item.status]}>{item.text}</Badge>
            </OverlayTrigger>
          </div>
        )
      })}
    </div>
  )
}
